import { gql } from "@apollo/client";

const PAY_VENDOR = gql`
  mutation payVendor($input: PayVendor!) {
    payVendor(input: $input) {
      status
      data
      error
    }
  }
`;
export default PAY_VENDOR;
